/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [
        //{
        //    extend: 'copy',
        //    exportOptions: {
        //        columns: [1, 2, 3, 4, 5]
        //    }
        //},
        {
            extend: 'csv',
            exportOptions: {
                columns: [1, 2, 3, 4, 5,
                    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
                ]
            }
        },
        {
            extend: 'pdf',
            exportOptions: {
                columns: [1, 2, 3, 4, 5]
            }
        },
        {
            extend: 'print',
            exportOptions: {
                columns: [1, 2, 3, 4, 5]
            }
        }
    ],
    dataTables_columns_export = [
        {data: 'email', name:'user.email', title: 'E-mail', orderable: false, searchable: false, visible: false}, // 7
        {data: 'salutation', name:'user.salutation', title: 'Salutation', orderable: false, searchable: false, visible: false}, // 8
        {data: 'job_title', name:'user.job_title', title: 'Job Title', orderable: false, searchable: false, visible: false}, // 9
        {data: 'address_1', name:'user.address_1', title: 'Address 1', orderable: false, searchable: false, visible: false}, // 10
        {data: 'address_2', name:'user.address_2', title: 'Address 2', orderable: false, searchable: false, visible: false}, // 11
        {data: 'address_3', name:'user.address_3', title: 'Address 3', orderable: false, searchable: false, visible: false}, // 12
        {data: 'town', name:'user.town', title: 'Town', orderable: false, searchable: false, visible: false}, // 13
        {data: 'postcode', name:'user.postcode', title: 'Postcode', orderable: false, searchable: false, visible: false}, // 14
        {data: 'phone_number', name:'user.phone_number', title: 'Phone number', orderable: false, searchable: false, visible: false}, // 15
        {data: 'mobile_number', name:'user.mobile_number', title: 'Mobile number', orderable: false, searchable: false, visible: false}, // 16
        {data: 'nationality', name:'country.nationality', title: 'Nationality', orderable: false, searchable: false, visible: false}, // 17
        {data: 'religion', name:'religion.name', title: 'Religion', orderable: false, searchable: false, visible: false}, // 18
        {data: 'gender', name:'gender', title: 'Gender', orderable: true, searchable: false, visible: false}, // 19
        {data: 'date_of_birth', name:'date_of_birth', title: 'Date of birth', orderable: false, searchable: false, visible: false}, // 20
        {data: 'national_insurance_number', name:'national_insurance_number', title: 'National Insurance Number', orderable: false, searchable: false, visible: false}, // 21
        {data: 'on_newsletter_list', name: 'on_newsletter_list', title: 'On newsletter list', orderable: false, searchable: false, visible: false}, // 22
        {data: 'on_voluntary_work_list', name: 'on_voluntary_work_list', title: 'On voluntary work list', orderable: false, searchable: false, visible: false}, // 23
    ]

$(function() {
    var $datatable_client_side = $('#datatable-all-guardians-client-side'),
        $dt2;

    $dt2 = $datatable_client_side.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "deferRender": true,
        "buttons": dataTables_buttons,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "order": [[ 1, "asc" ]],
        "initComplete": function() {

            this.api().columns().indexes().flatten().each( function ( i ) {
                var column = this.column( i );
                var select = $('<select><option value=""></option></select>')
                    .appendTo( $(column.footer()).empty() )
                    .on( 'change', function () {
                        // Escape the expression so we can perform a regex match
                        var val = $.fn.dataTable.util.escapeRegex(
                            $(this).val()
                        );

                        column
                                 .search( val ? '^'+val+'$' : '', true, false )
                       //     .search( val ? val : '', true, false )
                            //          .search( val ? '^awaiting' : '', true, false )
                            .draw();
                    } );

                column.data().unique().sort().each( function ( d, j ) {
                    select.append( '<option value="'+d+'">'+d+'</option>' )
                } );
            } );

        }
    });

    /**
     * Radio button on change event that changes searchbox input value
     */
    $("input[name=status_id]:radio").change(function () {

     //   var myValue = '^placed+$';
        var myValue = '\\b' + 'p';
        var myValue2 = '<span style="color:midnightblue">placed</span>';
        var regExSearch = '' + myValue + '';
        var regExSearch2 = "^" + myValue +"$";
        $dt2.columns(5).search(myValue, true, true).draw();

    });

    $('#datatable-all-guardians_filter input').keypress(function () {
        var $this = $(this),
            $radios = $("input[name=status_id]:radio"),
            $radioAll = $('#g_dt_radio_0');

        $radioAll.data('should-change', 'yes');
      /**  console.log($radioAll.data('should-change'));*/

        $radios.each(function( index ) {
            $(this).attr('checked', false);
        });

    });

});
